<div class="skill-table">
  <p-table
    [value]="teams"
    [scrollable]="true"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header">
      <tr pFrozenColumn alignFrozen="top">
        <th pSortableColumn="name" alignFrozen="left" pFrozenColumn>
          Teams
          <p-sortIcon field="name"/>
        </th>
        <th >
          Team members
        </th>
        <th pSortableColumn="lastMatrix">
          Last data
          <p-sortIcon field="lastMatrix"/>
        </th>
                <th  pSortableColumn="uploadedFilesCount">
          Sessions
          <p-sortIcon field="uploadedFilesCount"/>
        </th>

        <th pSortableColumn="active">
          Status
          <p-sortIcon field="active"/>
        </th>
        <th pSortableColumn="delete">
          Delete
          <p-sortIcon field="delete"/>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-columns="columns" let-rowData>

        <tr>
          <td  alignFrozen="left" pFrozenColumn>
            {{ rowData["name"] }}
          </td>
          <td>
        
{{ rowData["members"] }}
            
          </td>
          <td><!-- display date of last Skill Matrix -->
{{ rowData["lastMatrix"] | date: 'dd/MM/yyyy' }}
          </td>
                    <td>
            {{ rowData["uploadedfilescount"] || 0 }}
          </td>

          <td>
            <div class="field-checkbox mb-0 justify-content-center">
              <input
                type="checkbox"
                class="checkbox checkbox--skillteam"
                [(ngModel)]="rowData['active']"
                (change)="onTeamActiveToggle(rowData['id'], getChecked($event))"
              />
            </div>
          </td>
          <td>
        
            <!-- Display only if uploadedfilescount = 0 -->
            <button
              *ngIf="rowData['uploadedfilescount'] == '0'"
              [disabled]="rowData['active']"
              [pTooltip]="'Delete team ' + rowData['name']" 
              (click)="deleteTeam(rowData['id'])">
              <i class="pi pi-trash"></i>
              Delete team
              </button>
          </td>
        </tr>


    </ng-template>
  </p-table>
</div>
